import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import UserWebAPIUtils from 'utils/UserWebAPIUtils';
import SessionStore from 'stores/SessionStore';
import { BrowserRouter, Route } from 'react-router-dom';
const AccountAccessVerification = (props) => {
    const [loaded, setLoaded] = useState(null);
    const [redirect, setRedirect] = useState(null);
    useEffect(async () => {
        const user = SessionStore.getUser();
        setLoaded(false);
        if (props.location.pathname.indexOf('account-requests') !== -1 &&
            props.match.params.id &&
            props.match.params.id.length) {
            console.log('Attempting to link user account to account request');
            try {
                await UserWebAPIUtils.linkAccountAccessRequest(user._id, props.match.params.id);
                console.log('Linking successful');
                setRedirect('/carrier-center');
                setLoaded(true);
            }
            catch (e) {
                //Should this redirect somewhere else? Leaving this here for now..,.
                setRedirect('/carrier-center');
                setLoaded(true);
                console.log('error linking account access requests', props.match.params.id, 'err:', e.message);
            }
        }
    }, []);
    if (!loaded) {
        return React.createElement("div", null);
    }
    else {
        window.location.href = redirect;
        return;
    }
};
export default AccountAccessVerification;
